import { useState } from "react";

export const SERVICE_LOGOS: Record<string, string> = {
  spotify: "/service-logos/spotify.svg",
  "apple-music": "/service-logos/apple-music.svg",
  "youtube-premium": "/service-logos/youtube-premium.svg",
  netflix: "/service-logos/netflix.svg",
  "disney-plus": "/service-logos/disney-plus.svg",
  "amazon-prime": "/service-logos/amazon-prime.svg",
  max: "/service-logos/max.svg",
  "google-one": "/service-logos/google-one.svg",
  icloud: "/service-logos/icloud.svg",
  notion: "/service-logos/notion.svg",
  "xbox-game-pass": "/service-logos/xbox-game-pass.svg",
  "playstation-plus": "/service-logos/playstation-plus.svg",
};

interface ServiceLogoProps {
  serviceId: string;
  glyph?: string;
  className?: string;
}

export function ServiceLogo({ serviceId, glyph, className = "" }: ServiceLogoProps) {
  const [failed, setFailed] = useState(false);
  const source = SERVICE_LOGOS[serviceId];

  return (
    <span className={`service-logo ${className}`.trim()} aria-hidden="true">
      {source && !failed ? (
        <img alt="" decoding="async" onError={() => setFailed(true)} src={source} />
      ) : (
        <span>{glyph ?? serviceId.slice(0, 2).toUpperCase()}</span>
      )}
    </span>
  );
}
